'use client';

import { cn } from '@/lib/utils';
import { usePathname } from 'next/navigation';

const PATHS_WITH_BACKGROUND = ['/', '/quick-quote'];

export default function ComplianceNumber() {
  const pathname = usePathname();
  const backgroundClass = pathname === '/' ? 'bg-olive-50' : 'bg-neutral-0';

  return (
    <p
      className={cn(
        `body-sm text-neutral-400 pl-12 pb-5`,
        PATHS_WITH_BACKGROUND.includes(pathname!)
          ? 'bg-olive-50'
          : 'bg-neutral-0'
      )}
    >
      {'8180814.2 (4/28)'}
    </p>
  );
}
